'use client';

import DotsDropdown from '@/components/reservation/dots-dropdown';
import Togbutton from '@/components/reservation/togbutton';
import Checkbox from '@/components/ui/form-fields/checkbox';
import HeaderCell from '@/components/ui/table/header-cell';
import Avatar from '@/components/ui/avatar';
import Badge from '@/components/ui/badge';

export enum STATUS {
  Received = 'Received',
  Pending = 'Pending',
  Refund = 'Refund',
}

export function getStatus(status: string) {
  if (status === STATUS.Received) {
    return 'success';
  }
  if (status === STATUS.Pending) {
    return 'warning';
  }
  if (status === STATUS.Refund) {
    return 'danger';
  }
}

export const reservationColumn = (
  order: string,
  column: string,
  onSelectAll: (key: boolean) => any,
  onChange: (row: any) => any,
  onMore: (e: any, row: any) => any,
  onHeaderClick: (value: string) => any,
) => [
  {
    title: (
      <HeaderCell
        title={
          <Checkbox
            variant="outline"
            inputClassName="!bg-white focus:!ring-0"
            onChange={(e) => onSelectAll(e.target.checked)}
            iconClassName="bg-gray-dark rounded cursor-pointer"
          />
        }
        className="lg:pl-5"
      />
    ),
    dataIndex: 'checked',
    key: 'checked',
    width: 50,
    render: (checked: boolean, row: any) => (
      <div className="inline-flex cursor-pointer lg:pl-5">
        <Checkbox
          variant="outline"
          checked={row.checked}
          onChange={() => onChange(row)}
          inputClassName="!bg-white focus:!ring-0"
          iconClassName="bg-gray-dark rounded cursor-pointer"
        />
      </div>
    ),
  },
  {
    title: (
      <HeaderCell
        title={'SL.'}
        sortable={true}
        ascending={order === 'asc' && column === 'id'}
      />
    ),
    onHeaderCell: () => onHeaderClick('id'),
    dataIndex: 'id',
    key: 'id',
    width: 100,
  },
  {
    title: <HeaderCell title={'Date'} />,
    dataIndex: 'date',
    key: 'date',
    width: 150,
    render: (date: any) => <p className="whitespace-nowrap">{date}</p>,
  },
  {
    title: <HeaderCell title={'Title'} />,
    key: 'purchased',
    width: 200,
    render: (purchased: string) => (
      <p className="whitespace-nowrap">{purchased.title}</p>
    ),
  },
  {
    title: <HeaderCell title={'Status'} />,
    dataIndex: 'status',
    key: 'status',
    width: 150,
    render: (status: string) => {
      if (!status) return '__';

      // Define background color based on status
      const getBackgroundColor = (status: string) => {
        switch (status.toLowerCase()) {
          case 'active':
            return 'bg-green-500 text-white'; // Green for active
          case 'blocked':
            return 'bg-red-500 text-white'; // Red for blocked
          default:
            return 'bg-gray-500 text-white'; // Grey for others
        }
      };

      return (
        <Badge
          className={`badge uppercase px-2 py-1 rounded ${getBackgroundColor(status)}`}
        >
          {status}
        </Badge>
      );
    },
  },

  {
    title: <HeaderCell title={'Property Image'} />,

    key: 'name',
    width: 200,
    render: (customer: any) => (
      <div className="flex items-center gap-3">
        <Avatar src={customer.Thumb} size="40" />
      </div>
    ),
  },
  {
    title: <HeaderCell title={'Listed'} />,
    key: 'listed',
    width: 200,
    render: (row: any) => (
      <div className="flex items-center gap-3">
        <Togbutton status={row.listed} id={row.id} />
      </div>
    ),
  },
  {
    title: <HeaderCell title={'Revenue'} />,

    key: 'Listed Price',
    width: 100,
    render: (value: string) => <p className="font-bold">${value.price}</p>,
  },
  {
    title: '',
    dataIndex: 'action',
    key: 'action',
    width: 50,
    render: (value: any, row: any) => (
      <div className="flex items-center gap-2">
        <DotsDropdown
          key={row.id}
          row={row}
          onClick={(e: any) => onMore(e, row)}
        />
      </div>
    ),
  },
];
